import { createGlobalStyle } from 'styled-components';

const GlobalFonts = createGlobalStyle`
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');
    @import url('https://use.typekit.net/gzq5pzl.css');
`;

export default GlobalFonts;
